import {Component, OnInit} from '@angular/core';
import {CustomMessageKey, UtilService} from "library";
import { PrimeNGConfig } from 'primeng/api';
import {Router} from "@angular/router";
import {PixelService} from "./services/api/v1/pixel.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  pageLoading: boolean = false;

  constructor(private utilService: UtilService,
              private config: PrimeNGConfig, private router: Router, private pixelService: PixelService,) { }

  ngOnInit() {
    this.utilService.pageLoading.subscribe(resp => {
      setTimeout(() => this.pageLoading = resp, 0);
    });

    this.config.setTranslation({
      "monthNames": ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
      "monthNamesShort": ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      "dayNames": ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
      "dayNamesShort": ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
      "dayNamesMin": ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
      "today": "Hoy",
      "clear": "Limpiar",
      "reject": "No",
      "accept": "Si",
    });
  }

  protected readonly CustomMessageKey = CustomMessageKey;
}
